var setSiteCookies;

setSiteCookies = require('./setSiteCookies');

Groupon.setWindowLocation = require('./setWindowLocation');

module.exports = Groupon.Utils.changeUserLanguage = function(language) {
  var alternate, href, hreflang;
  setSiteCookies({
    user_locale: null
  });
  setSiteCookies({
    user_locale: language
  });
  hreflang = "[hreflang='" + language.replace('_', '-') + "']";
  if ((alternate = $("head link" + hreflang).attr("href"))) {
    href = alternate;
  } else {
    href = '/';
  }
  return Groupon.setWindowLocation(href);
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvY29yZS9mcm9udGVuZC9ncm91cG9uX21vZHVsZXMvY2hhbmdlVXNlckxhbmd1YWdlLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9hcmljaHRlci9yZXBvc2l0b3JpZXMvc2xzL2NvcmUvZnJvbnRlbmQvZ3JvdXBvbl9tb2R1bGVzL2NoYW5nZVVzZXJMYW5ndWFnZS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxjQUFBLEdBQWlCLE9BQUEsQ0FBUSxrQkFBUjs7QUFDakIsT0FBTyxDQUFDLGlCQUFSLEdBQTRCLE9BQUEsQ0FBUSxxQkFBUjs7QUFFNUIsTUFBTSxDQUFDLE9BQVAsR0FBaUIsT0FBTyxDQUFDLEtBQUssQ0FBQyxrQkFBZCxHQUFtQyxTQUFDLFFBQUQ7QUFDbEQsTUFBQTtFQUFBLGNBQUEsQ0FBZTtJQUFBLFdBQUEsRUFBYSxJQUFiO0dBQWY7RUFDQSxjQUFBLENBQWU7SUFBQSxXQUFBLEVBQWEsUUFBYjtHQUFmO0VBQ0EsUUFBQSxHQUFXLGFBQUEsR0FBZ0IsUUFBUSxDQUFDLE9BQVQsQ0FBaUIsR0FBakIsRUFBc0IsR0FBdEIsQ0FBaEIsR0FBNkM7RUFFeEQsSUFBRyxDQUFDLFNBQUEsR0FBWSxDQUFBLENBQUUsV0FBQSxHQUFjLFFBQWhCLENBQXlCLENBQUMsSUFBMUIsQ0FBK0IsTUFBL0IsQ0FBYixDQUFIO0lBQ0UsSUFBQSxHQUFPLFVBRFQ7R0FBQSxNQUFBO0lBR0UsSUFBQSxHQUFPLElBSFQ7O1NBS0EsT0FBTyxDQUFDLGlCQUFSLENBQTBCLElBQTFCO0FBVmtEIn0=
